
import { useQuery } from '@tanstack/react-query';
import { fetchDevice, fetchDeviceTypes } from '../api/devices';

export function useDevice(deviceId) {
  return useQuery({
    queryKey: ['device', deviceId],
    queryFn: () => fetchDevice(deviceId),
    enabled: !!deviceId,
  });
}


export function useDeviceList() {
  return useQuery({
    queryKey: ['deviceList'],
    queryFn: () => fetchDeviceTypes(),
  });
}
